const Notification_Url = "http://localhost:5000";
// const Notification_Url = "https://octane.air2o.net";
export default Notification_Url;